export const BREAKPOINTS = {
	xs: 450,
	sm: 600,
	md: 900,
	lg: 1200,
	xl: 1500,
	xxl: 2200,
} as const satisfies Record<string, number>;

export type Breakpoint = keyof typeof BREAKPOINTS;
